module.exports = __webpack_public_path__ + "static/media/sun.ba5c98bd.svg";